/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_HeadingInputs */

const en_terms_heading = /** @type {(inputs: Terms_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms of Service`)
};

const lv_terms_heading = /** @type {(inputs: Terms_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lietošanas noteikumi`)
};

/**
* | output |
* | --- |
* | "Terms of Service" |
*
* @param {Terms_HeadingInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const terms_heading = /** @type {((inputs?: Terms_HeadingInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_HeadingInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_terms_heading(inputs)
	return en_terms_heading(inputs)
});